export default "__VITE_ASSET__CVUltFMn__"